import { createSlice } from "@reduxjs/toolkit";

export const currentlyCultivatedCrops = createSlice({
  name: "cultivated-field-crops",
  initialState: {
    value: {
      status: false,
      data: [] as { plantName: string; userId: string }[],
      duplicateRemoved: [] as { plantName: string; userId: string }[],
    },
  },
  reducers: {
    updateCultivatedCrops: (state, action) => {
      state.value.status = true;
      state.value.data = action?.payload?.data;
      state.value.duplicateRemoved = action?.payload?.duplicateRemoved;
    },
    addCultivatedCropToList: (state, action) => {
      state.value.data = [...state.value.data, action?.payload];
    },
    clearCultivatedCropList: (state) => {
      state.value.status = false;
      state.value.data = [];
      state.value.duplicateRemoved = [];
    },
  },
});

export const {
  updateCultivatedCrops,
  addCultivatedCropToList,
  clearCultivatedCropList,
} = currentlyCultivatedCrops.actions;

export default currentlyCultivatedCrops.reducer;
